export function formatList(list, field = "id"){
    let newList = {}
    if (list) {
        list = list.reverse()
        list.map( item =>{
            newList[item[field]] = item
        })
    }
    return newList
}
export function formatListAccess(list){
    let newList = {}
    if (list) {
        list = list.reverse()
        list.map( item => {
            item.access_pages = item.access_pages.split(", ")
            newList[item.access_id] = item
        })
    }
    return newList
}


export function orderByAsc(list, field = "name"){
    list.sort( (a, b) => {
        if (a[field] > b[field]) return -1;
        if (b[field] > a[field]) return 1;

        return 0;
    })
    return list
}
export function orderByDsc(list, field = "name"){
    let newList = orderByAsc(list, field)
    return newList.reverse()
}

export function orderByDateAsc(list, field = "date"){
    list.sort( (a, b) => {
        if (new Date(a[field]) > new Date(b[field])) return -1;
        if (new Date(b[field]) > new Date(a[field])) return 1;

        return 0;
    })
    return list
}
export function orderByDateDsc(list, field = "date"){
    let newList = orderByDateAsc(list, field)
    return newList.reverse()

}


export function capitalize(list, field) {
    let newList = list.map( item => {
        let words = item[field].split(" ")
        words = words.map( word => word && word[0].toUpperCase() + word.slice(1).toLowerCase())
        item[field] = words.join(" ")
        return item
    })
    return newList
}
export function capitalizeWord(name) {
    let words = name.split(" ")
    words = words.map( word => word && word[0].toUpperCase() + word.slice(1).toLowerCase())
    name = words.join(" ")
        
    return name
}